import PaginaPrincipal from '../paginas/principal/PaginaPrincipal.vue'
import VueRouter from "vue-router";
import Vue from 'vue';
import InfoPagina from "../paginas/info/InfoPagina";
import OpinionPagina from "../paginas/opinion/OpinionPagina";
import DescargasPagina from "../paginas/descargas/DescargasPagina";
import LoginPagina from "../paginas/login/LoginPagina";
import RegistroPagina from "../paginas/registro/RegistroPagina";
import ProyectoListadoPagina from "../paginas/proyecto-listado/ProyectoListadoPagina";
import ProyectoNuevoPagina from "../paginas/proyecto-nuevo/ProyectoNuevoPagina";
import ProyectoDetallesPagina from "../paginas/proyecto-detalles/ProyectoDetallesPagina";
import ProyectoResultadosPagina from "../paginas/proyecto-resultados/ProyectoResultadosPagina";
import AdminMuestreosPagina from "../paginas/admin-muestreos/AdminMuestreosPagina";
import RecuperarContrasenyaPagina from "../paginas/recuperar-contrasenya/RecuperarContrasenyaPagina";
import CambiarContrasenyaPagina from "../paginas/cambiar-contrasenya/CambiarContrasenyaPagina";
import PerfilPagina from "../paginas/perfil/PerfilPagina";

import store from "../store/store-app";
import AvisoLegalPagina from "@/paginas/aviso-legal/AvisoLegalPagina";
import PoliticaPrivacidadPagina from "@/paginas/politica-privacidad/PoliticaPrivacidadPagina";
import AdminRegistroDescargasPagina from "@/paginas/admin-registro-descargas/AdminRegistroDescargasPagina";
import ProyectoGuardadoPagina from "../paginas/proyecto-guardado/ProyectoGuardadoPagina";
import MaterialGuardadoPagina from "@/paginas/material-guardado/MaterialGuardadoPagina";
import BibliotecaPagina from "@/paginas/biblioteca/BibliotecaPagina";
import MaterialDetallesPagina from "@/paginas/material-detalles/MaterialDetallesPagina";
import ReenviarCodigoActivacionPagina from "@/paginas/reenviar-codigo-activacion/ReenviarCodigoActivacionPagina";
import ActivarCuentaPagina from "@/paginas/activar-cuenta/ActivarCuentaPagina";
import AdminConstantesPagina from "../paginas/admin-constantes/AdminConstantesPagina";
import AdminIndicadoresPagina from "../paginas/admin-indicadores/AdminIndicadoresPagina";
import AdminConstantesDetallesPagina from "../paginas/admin-constantes-detalles/AdminConstantesDetallesPagina";
import AdminIndicadoresDetallesPagina from "../paginas/admin-indicadores-detalles/AdminIndicadoresDetallesPagina";

Vue.use(VueRouter);

let comprobarUsuario = (to, from, next) => {
    if (store.getters.hayUsuario) next();
    else next("/");
};

let comprobarNoUsuario = (to, from, next) => {
    if (store.getters.hayUsuario) next("/");
    else next();
};

let comprobarAdmin = (to, from, next) => {
    if (store.getters.usuarioEsAdmin) next();
    else next("/");
};

const routes = [
    {path: '/', name: 'inicio', component: PaginaPrincipal},
    {path: '/info/:page', name: 'info', component: InfoPagina},
    {path: '/opinion', name: 'opinion', component: OpinionPagina},
    {path: '/descargas', name: 'descargas', component: DescargasPagina},
    {path: '/login', name: 'login', component: LoginPagina, beforeEnter: comprobarNoUsuario},
    {path: '/registro', name: 'registro', component: RegistroPagina, beforeEnter: comprobarNoUsuario},
    {path: '/perfil', name: 'perfil', component: PerfilPagina, beforeEnter: comprobarUsuario},
    {
        path: '/proyecto-listado',
        name: 'proyecto-listado',
        component: ProyectoListadoPagina,
        beforeEnter: comprobarUsuario
    },
    {
        path: '/proyecto-guardado',
        name: 'proyecto-guardado',
        component: ProyectoGuardadoPagina,
        beforeEnter: comprobarUsuario
    },
    {
        path: '/material-guardado',
        name: 'material-guardado',
        component: MaterialGuardadoPagina,
        beforeEnter: comprobarUsuario
    },
    {
        path: '/material-detalles/:id', name: 'material-detalles', component: MaterialDetallesPagina,
        props: route => ({id: parseInt(route.params.id)})
    },
    {path: '/biblioteca', name: 'biblioteca', component: BibliotecaPagina, props: true},
    {path: '/proyecto-nuevo', name: 'proyecto-nuevo', component: ProyectoNuevoPagina, props: true},
    {path: '/proyecto-detalles/:id', name: 'proyecto-detalles', component: ProyectoDetallesPagina},
    {path: '/proyecto-resultados/:id/:area/:tipo', name: 'proyecto-resultados', component: ProyectoResultadosPagina},
    {path: '/admin-muestreos', name: 'admin-muestreos', component: AdminMuestreosPagina, beforeEnter: comprobarAdmin},
    {
        path: '/admin-constantes',
        name: 'admin-constantes',
        component: AdminConstantesPagina,
        beforeEnter: comprobarAdmin
    },
    {
        path: '/admin-constantes-detalles/:id',
        name: 'admin-constantes-detalles',
        component: AdminConstantesDetallesPagina,
        beforeEnter: comprobarAdmin,
        props: route => ({id: parseInt(route.params.id)})
    },
    {
        path: '/admin-indicadores',
        name: 'admin-indicadores',
        component: AdminIndicadoresPagina,
        beforeEnter: comprobarAdmin
    },
    {
        path: '/admin-indicadores-detalles/:id',
        name: 'admin-indicadores-detalles',
        component: AdminIndicadoresDetallesPagina,
        beforeEnter: comprobarAdmin,
        props: route => ({id: parseInt(route.params.id)})
    },
    {
        path: '/admin-registro-descargas',
        name: 'admin-registro-descargas',
        component: AdminRegistroDescargasPagina,
        beforeEnter: comprobarAdmin
    },
    {
        path: '/recuperar-contrasenya',
        name: 'recuperar-contrasenya',
        component: RecuperarContrasenyaPagina,
        beforeEnter: comprobarNoUsuario
    },
    {
        path: '/cambiar-contrasenya',
        name: 'cambiar-contrasenya',
        component: CambiarContrasenyaPagina,
        beforeEnter: comprobarNoUsuario
    },
    {
        path: '/reenviar-codigo-activacion',
        name: 'reenviar-codigo-activacion',
        component: ReenviarCodigoActivacionPagina,
        beforeEnter: comprobarNoUsuario
    },
    {
        path: '/activar-cuenta',
        name: 'activar-cuenta',
        component: ActivarCuentaPagina,
        beforeEnter: comprobarNoUsuario
    },
    {path: '/aviso-legal', name: "aviso-legal", component: AvisoLegalPagina},
    {path: '/politica-privacidad', name: "politica-privacidad", component: PoliticaPrivacidadPagina}
];

let routerInstance = new VueRouter({
    routes
});

routerInstance.beforeEach((to, from, next) => {
    store.dispatch('cargarUsuario').then(() => {
        next()
    });
});

export default routerInstance;